<template>
	<footer ref="el" data-component="footer">
		<span class="inner-bg" />
		<div class="background-container">
			<!-- <nuxt-img class="desktop" src="/imgs/temp/footer.jpg" alt="desktop footer graphic" />
			<nuxt-img class="mobile" src="/imgs/temp/mobilefooter.jpg" alt="mobile footer graphic" /> -->

			<ClientOnly>
				<Waves dark />
			</ClientOnly>
		</div>

		<div class="g-row top-row">
			<h2 class="-title-3 title">{{ title }}</h2>
			<div v-if="ctas" class="ctas-container">
				<Button v-for="(cta, k) in ctas" :key="k" v-bind="cta" :tone="k === 0 ? 'primary' : 'secondary'" />
			</div>
		</div>

		<div class="certs-wrapper desktop">
			<CertificationState v-for="(cert, i) in certificates" :key="i" v-bind="cert" />
		</div>

		<div class="bottom-row desktop">
			<div class="g-row social-legal-row">
				<div class="g-col xxl-16 social-legal">
					<div class="socials">
						<a href="https://www.linkedin.com/company/silk-river/" target="_blank" rel="noopener noreferrer">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM6.15 9.975V18H8.7V9.975H6.15ZM6 7.425C6 8.25 6.6 8.85 7.425 8.85C8.25 8.85 8.85 8.25 8.85 7.425C8.85 6.6 8.25 6 7.425 6C6.675 6 6 6.6 6 7.425ZM15.45 18H17.85V13.05C17.85 10.575 16.35 9.75 14.925 9.75C13.65 9.75 12.75 10.575 12.525 11.1V9.975H10.125V18H12.675V13.725C12.675 12.6 13.425 12 14.175 12C14.925 12 15.45 12.375 15.45 13.65V18Z"
									fill="#0551F5"
								/>
							</svg>
						</a>
					</div>

					<div class="legals">
						<NuxtLink v-for="(page, i) in legalPageLinks" :key="page.key || i" :to="page.href" :external="page.external" :target="page.target"
							><p class="-body-regular">{{ page.title }}</p></NuxtLink
						>
					</div>
				</div>
			</div>

			<!-- 		
			<svg class="cross-line" viewBox="0 0 1668 168" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1760.5 166.75L1096.92 166.75C1056.1 166.75 1035.7 166.75 1016.3 162.874C992.557 158.131 969.876 149.117 949.356 136.271C932.587 125.772 917.747 111.765 888.067 83.75C858.387 55.735 843.547 41.7275 826.777 31.2293C806.258 18.3833 783.577 9.36946 759.837 4.62627C740.436 0.749985 720.029 0.74998 679.216 0.74997L617.748 0.749954H-10.5"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg> -->
			<svg class="cross-line" viewBox="0 0 1668 168" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1668 166.75L1206.92 166.75C1166.1 166.75 1145.7 166.75 1126.3 162.874C1102.56 158.131 1079.88 149.117 1059.36 136.271C1042.59 125.772 1027.75 111.765 998.067 83.75C968.387 55.735 953.547 41.7275 936.777 31.2293C916.258 18.3833 893.577 9.36946 869.837 4.62628C850.436 0.749991 830.029 0.749987 789.216 0.749981L617.748 0.749954H-10.5"
					stroke="#0551F5"
					stroke-width="1.5"
				/>
			</svg>

			<div class="g-row copyrights-logo">
				<div class="g-col xxl-9 logo-wrapper">
					<Logo class="logo" variant="footer" />
				</div>

				<div class="g-col xxl-2 copyright-wrapper">
					<a href="http://burocratik.com" target="_blank" rel="noopener noreferrer"><p class="-body-regular">Made by Büro</p></a>
				</div>
			</div>
		</div>

		<div class="bottom-row mobile">
			<div class="g-row social-legal-row">
				<div class="g-col xxl-16 sm-14 sm-offset-1 social-legal">
					<div class="legals">
						<NuxtLink v-for="(page, i) in legalPageLinks" :key="page.key || i" :to="page.href" :external="page.external" :target="page.target"
							><p class="-body-regular">{{ page.title }}</p></NuxtLink
						>
					</div>
					<div class="certs-wrapper">
						<CertificationState v-for="(cert, i) in certificates" :key="i" v-bind="cert" />
					</div>
				</div>

				<div class="g-col xxl-16 sm-14 sm-offset-1 socials-svg-copyrights">
					<div class="socials">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM6.15 9.975V18H8.7V9.975H6.15ZM6 7.425C6 8.25 6.6 8.85 7.425 8.85C8.25 8.85 8.85 8.25 8.85 7.425C8.85 6.6 8.25 6 7.425 6C6.675 6 6 6.6 6 7.425ZM15.45 18H17.85V13.05C17.85 10.575 16.35 9.75 14.925 9.75C13.65 9.75 12.75 10.575 12.525 11.1V9.975H10.125V18H12.675V13.725C12.675 12.6 13.425 12 14.175 12C14.925 12 15.45 12.375 15.45 13.65V18Z"
								fill="#0551F5"
							/>
						</svg>
					</div>

					<svg class="cross-line" preserveAspectRatio="xMaxYMid" viewBox="0 0 366 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M366 46.75H249.175C232.262 46.75 216.534 38.0645 207.526 23.75C198.517 9.43548 182.789 0.750028 165.876 0.750025L53.8329 0.75H0" stroke="#0551F5" stroke-width="1.5" />
					</svg>

					<p class="-body-regular">Made by Büro</p>
				</div>
			</div>

			<div class="logo-wrapper">
				<Logo class="logo" variant="footer" />
			</div>
		</div>
	</footer>
</template>

<script setup>
import { gsap, ScrollTrigger } from 'gsap/all'

import { Button, Logo } from '~/components/primitives'
import { CertificationState } from '~/components/fragments'

import.meta.client && gsap.registerPlugin(ScrollTrigger)

const Waves = defineAsyncComponent(() => import('@/components/sections/Three/Waves.vue'))

const props = defineProps({
	title: { type: String, default: undefined },
	ctas: { type: Array, default: undefined },
	secondaryPages: { type: Array, default: undefined },
	socials: { type: Array, default: undefined },
	legalPages: { type: Array, default: undefined },
	certificates: { type: Array, default: undefined },
})

const legalPageLinks = computed(() => {
	const pages = Array.isArray(props.legalPages) ? props.legalPages : []

	return pages
		.map((page, index) => {
			const title = typeof page?.title === 'string' ? page.title.trim() : ''
			if (!title) return null

			if (page?.type === 'external') {
				const url = typeof page?.url === 'string' ? page.url.trim() : ''
				if (!url) return null

				return {
					key: page?._key || `${url}-${index}`,
					title,
					href: url,
					external: true,
					target: url.startsWith('http') ? '_blank' : undefined,
				}
			}

			const slug = typeof page?.slug === 'string' ? page.slug.trim().replace(/^\/+|\/+$/g, '') : ''
			if (!slug) return null

			return {
				key: page?._key || `${slug}-${index}`,
				title,
				href: `/legal/${slug}`,
			}
		})
		.filter(Boolean)
})

const el = ref(null)
const context = inject('pageContext')
let logoRevealTweens = []
let removeLoadRefreshListener = null

const getVisibleLogoElements = () => {
	if (!import.meta.client || !el.value) return []

	return Array.from(el.value.querySelectorAll('.logo-wrapper .logo')).filter((logoElement) => {
		const wrapperElement = logoElement.closest('.logo-wrapper')
		if (!wrapperElement) return false

		const wrapperStyle = window.getComputedStyle(wrapperElement)
		return wrapperStyle.display !== 'none' && wrapperStyle.visibility !== 'hidden' && wrapperElement.getClientRects().length > 0
	})
}

const scheduleRefresh = () => {
	if (!import.meta.client) return
	nextTick(() => requestAnimationFrame(() => ScrollTrigger.refresh()))
}

const setupLoadRefresh = () => {
	if (!import.meta.client) return

	const onLoad = () => scheduleRefresh()
	window.addEventListener('load', onLoad, { once: true })
	removeLoadRefreshListener = () => window.removeEventListener('load', onLoad)
}

const setup = () => {
	if (!import.meta.client || !el.value) return

	const logoElements = getVisibleLogoElements()
	logoElements.length && gsap.set(logoElements, { yPercent: 100 })
}

const init = () => {
	if (!import.meta.client || !el.value) return

	const logoElements = getVisibleLogoElements()
	if (!logoElements.length) return

	logoElements.forEach((logoElement) => {
		const wrapperElement = logoElement.closest('.logo-wrapper')
		if (!wrapperElement) return

		const revealTween = gsap.fromTo(
			logoElement,
			{
				yPercent: 100,
			},
			{
				yPercent: -0.2,
				ease: 'none',
				scrollTrigger: {
					trigger: wrapperElement,
					start: () => `top ${window.innerHeight}px`,
					end: () => `+=${wrapperElement.offsetHeight - 1 || wrapperElement.getBoundingClientRect().height || 0}`,
					scrub: true,
					invalidateOnRefresh: true,
					// markers: true,
				},
			}
		)

		logoRevealTweens.push(revealTween)
	})
}

const kill = () => {
	logoRevealTweens.forEach((tween) => {
		tween.scrollTrigger?.kill()
		tween.kill()
	})
	logoRevealTweens = []
}

onBeforeUnmount(() => {
	kill()
	removeLoadRefreshListener?.()
	removeLoadRefreshListener = null
})

onMounted(() => {
	const loader = context?.$page?.loader
	setup()
	setupLoadRefresh()
	if (!loader) {
		init()
		scheduleRefresh()
		return
	}
	loader.ready.then(() => {
		init()
		scheduleRefresh()
	})
})
</script>

<style lang="scss" scoped>
[data-component='footer'] {
	position: relative;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	width: 100vw;
	min-height: 820px;
	height: 100vh;
	height: 100dvh;
	min-height: max(820px, 100svh);

	color: var(--color-geral-white);

	overflow: hidden;

	@include max-width($sm) {
		// margin-bottom: rs(70, 50);
	}

	.inner-bg {
		position: absolute;
		inset: rs(16, 12);
		border-radius: rs(34, 20);
		background-color: var(--color-river-blue-900);
		overflow: hidden;
	}

	.inner {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.top-row {
		position: relative;

		flex-direction: column;
		justify-content: center;
		align-items: center;

		text-align: center;

		margin-top: rs(230, 129);

		.title {
			white-space: pre-line;
			color: var(--color-geral-white);

			width: column-width(6, true);

			@include max-width($lg) {
				width: column-width(8, true);
			}

			@include max-width($md) {
				width: column-width(10, true);
			}

			@include max-width($sm) {
				width: column-width(15);
			}
		}

		.ctas-container {
			display: flex;
			gap: rs(24, 24);
			margin-top: rs(24, 24);
		}
	}

	.certs-wrapper {
		position: absolute;
		right: calc(#{rs(16, 12)} + var(--grid-padding));
		top: rs(56, 52);

		display: flex;
		align-items: flex-end;
		justify-content: flex-start;
		gap: rs(12, 12);

		margin-bottom: rs(42, 42);

		* {
			white-space: nowrap;
		}
	}

	.bottom-row {
		position: relative;

		flex-direction: column;
		padding-bottom: rs(15, 15);

		.social-legal-row {
			margin-bottom: rs(50, 40);

			.social-legal {
				display: flex;
				flex-direction: row;
				gap: rs(40, 40);

				.socials {
					display: flex;
					flex-direction: row;
					gap: rs(12, 12);
					a {
						transition: 0.3s ease;
						transform-origin: center;

						@media (hover: hover) {
							&:hover {
								transform: scale(1.05);
							}
						}
					}
				}

				.legals {
					display: flex;
					flex-direction: row;
					gap: rs(40, 40);

					a {
						transition: 0.3s ease;
						@media (hover: hover) {
							&:hover {
								opacity: 0.8;
							}
						}
					}

					p {
						color: var(--color-river-blue-100);
					}
				}
			}
		}

		.cross-line {
			pointer-events: none;
			position: absolute;
			left: 0;
			bottom: rs(45, 0);
			width: 100%;

			clip-path: inset(0 rs(16, 16) 0 rs(16, 16));
		}

		.copyrights-logo {
			justify-content: space-between;

			.logo-wrapper {
				width: 100%;
				height: fit-content;
				overflow: hidden;
				margin-bottom: 1px;

				:deep(.logo) {
					width: 100%;
					height: fit-content;
					svg {
						width: 100%;
						height: auto;
					}
				}
			}

			.copyright-wrapper {
				display: flex;
				justify-content: flex-end;
				align-items: flex-end;

				a {
					transition: 0.3s ease;
					@media (hover: hover) {
						&:hover {
							opacity: 0.8;
						}
					}
				}

				p {
					color: var(--color-river-blue-100);
					margin-bottom: rs(39, 39);
					white-space: nowrap;
				}
			}
		}
	}

	.bottom-row.mobile {
		position: relative;

		flex-direction: column;
		padding-bottom: rs(15, 15);

		.social-legal-row {
			margin-bottom: rs(50, 40);

			.social-legal {
				display: flex;
				flex-direction: column;

				margin-bottom: rs(34, 34);

				.legals {
					display: flex;
					flex-direction: column;
					gap: rs(20, 20);

					p {
						color: var(--color-river-blue-100);
					}
				}
			}
		}

		.socials-svg-copyrights {
			position: relative;

			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-content: center;

			margin-top: rs(40, 10);
			margin-bottom: rs(40, 10);

			.cross-line {
				pointer-events: none;
				position: absolute;
				left: 0;
				bottom: initial;
				width: 100%;

				// clip-path: inset(0 rs(16, 16) 0 rs(16, 16));

				pointer-events: none;
				position: absolute;
				top: rs(-35, -15);
				// left: calc(column-width(1, true) - var(--grid-padding) - var(--grid-gap) * -1);
				left: calc(column-width(1) * -1 - var(--grid-padding) - var(--grid-half-gap) * 2);

				width: calc(100% + column-width(3) - var(--grid-half-gap));
			}
			.-body-regular {
				color: var(--color-river-blue-100);
				white-space: nowrap;
			}
		}

		.logo-wrapper {
			width: 100%;
			height: fit-content;
			overflow: hidden;

			:deep(.logo) {
				width: calc(100% - var(--grid-padding) * 2 - column-width(1));
				height: fit-content;

				margin: 0 auto;

				margin-bottom: -3px;

				svg {
					width: 100%;
					height: auto;
				}
			}
		}

		.certs-wrapper {
			position: relative;
			top: initial;
			right: initial;

			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			gap: rs(12, 12);

			margin-bottom: rs(10, 10);
		}

		.copyright-wrapper {
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;

			p {
				color: var(--color-river-blue-100);
				margin-bottom: rs(39, 39);
				white-space: nowrap;
			}
		}
	}

	.background-container {
		position: absolute;
		inset: rs(16, 12);
		border-radius: rs(34, 20);
		overflow: hidden;

		:deep(img) {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.mobile {
		display: none;
		visibility: hidden;
		pointer-events: none;
	}
	.desktop {
		display: flex;
	}
	@include max-width($sm) {
		.mobile {
			display: block;
			visibility: visible;
			pointer-events: all;
		}
		.desktop {
			display: none;
			visibility: hidden;
			pointer-events: none;
		}
	}
}
</style>
